import { ChangeDetectorRef, Component, Input, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TextSizes, TextType, UserDataImgBorder, UserDataImgSize } from 'src/app/shared/enums';
import { befreeUrlValues } from 'src/app/shared/constants';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { IonicModule } from '@ionic/angular';
import { RouterLink } from '@angular/router';
import { ImageComponent } from '../image/image.component';
import { NgClass } from '@angular/common';
import { TextComponent } from '../text/text.component';
import { DateFormatPipe } from '../../pipe/date-format/date-format.pipe';
import { AddBaseUrlPipe } from '../../pipe/add-baseUrl/add-base-url.pipe';
import { SvgComponent } from '../svg/svg.component';
import { YearsOfServiceBadgeIconPipe } from '../../pipe/years-of-service-badge-icon/years-of-service-badge-icon.pipe';
@Component({
  selector: 'app-user-data',
  templateUrl: './user-data.component.html',
  styleUrls: ['./user-data.component.scss'],
  imports: [
    IonicModule,
    RouterLink,
    ImageComponent,
    TextComponent,
    NgClass,
    DateFormatPipe,
    AddBaseUrlPipe,
    SvgComponent,
    YearsOfServiceBadgeIconPipe,
  ],
})
export class UserDataComponent {
  private _cdr = inject(ChangeDetectorRef);
  utils = inject(UtilsService);

  @Input() id?: number;

  @Input() imgSrc: string | undefined;

  @Input() fullName: string | undefined;

  @Input() position: string | undefined;

  @Input() date: string | undefined;

  @Input() imgSize: string = UserDataImgSize.m;

  @Input() email: string | undefined;

  @Input() dateEmployment: string | undefined;

  readonly TextSizes = TextSizes;

  readonly TextType = TextType;

  readonly UserDataImgSize = UserDataImgSize;

  readonly UserDataImgBorder = UserDataImgBorder;

  readonly befreeUrl = environment.befreeUrl;

  public isActive = false;

  get link() {
    return this.id ? ['/', befreeUrlValues.dashboard, befreeUrlValues.employees, this.id] : null;
  }

  public onClick() {
    this.isActive = true;
    setTimeout(() => {
      this.isActive = false;
      this._cdr.detectChanges();
    }, 200);
  }
}
